import { moveItems } from '../api/items';

export const moveItemNodes = ({ nodes, catalogId, categoryId, fromCategoryId }) =>
  moveItems({
    catalogId,
    categoryId,
    fromCategoryId,
    items: nodes.map((node) => node.item),
  });
